import React from "react";

const SoleTraderForm = () => {
  return <div>SoleTraderForm</div>;
};

export default SoleTraderForm;
